// extracted by mini-css-extract-plugin
export default {"button":"SkipButton_button__vpdbi","--secondary":"SkipButton_--secondary__WGj9a"};